export const IMAGE_FILE_SIZE_LIMIT = 2000000;
